import { z } from 'zod';
import { c } from '../../../contract';
import { TypeformEvent } from '../../../types/Webhooks/TypeformEvent';

export const typeformRouter = c.router(
  {
    galateaCancelationSurveyResponses: {
      summary: 'Handles Galatea cancelation survey responses from Typeform',
      method: 'POST',
      path: '/galatea-cancelation-survey-responses',
      body: TypeformEvent,
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
  },
  { pathPrefix: '/typeform' },
);
